import React from "react";
import { Result } from "antd";
import { useTranslation } from "react-i18next";

const UserBlocked = () => {
  const { t } = useTranslation();
  // Get Query Parameter "t"
  const urlParams = new URLSearchParams(window.location.search);
  const errorType = urlParams.get("t") || "X-632";

  return (
    <div className="container">
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        status="500"
        title={t("userBlocked.title")}
        subTitle={t("userBlocked.subTitle", { errorType })}
      />
    </div>
  );
};

export default UserBlocked;
